





import Vue from 'vue';
import Component from 'vue-class-component';
import UserApi from '@/api/UserApi';
import {CommonModelUtils, SponsorSelectDialogResponse} from '@/model/CommonModel';
import ApiUtils from '@/utils/ApiUtils';
import {Prop} from 'vue-property-decorator';
import {ComponentEventBus} from '@/store';

@Component({
    components: {}
})
export default class SessionSelector extends Vue {
    @Prop({default: ''}) private readonly id: string;

    get label() {
        return this.$route.meta.isAdmin ? `${this.$t('message.header.system')}`
            : `${this.$store.getters.senderName}(${this.$store.getters.organization})`;
    }
    
    get componentId() {
        return this.id;
    }

    get getStyleWidth() {
      return {width: this.$route.meta.isAdmin ? 'auto' : '200px'};
    }
    
    public showSponsorSenderSelectDialog() {
        UserApi.retrieveUserSponsors(this.$store.getters.userKey).then(res => {
            const sponsors = res.data.sponsorList;
            
            const selectedSponsorKey = this.$route.params.sponsorKey;
            const selectedSenderKey = this.$route.params.sessionSenderKey;
            this.$modal.showSponsorSelectDialog({
                selectedSponsorKey,
                selectedSenderKey,
                sponsors,
                userKey: this.$store.getters.userKey,
                width: '600px',
                onConfirm: (selected: SponsorSelectDialogResponse) => {
                    if (CommonModelUtils.compareKey(selected.sponsorKey, selectedSponsorKey)
                        && CommonModelUtils.compareKey(selected.sessionSenderKey, selectedSenderKey)) {
                        return;
                    }
                    
                    this.$store.commit('initChangeMap');
                    this.$router.push({
                            name: 'Home',
                            params: {
                                ...ApiUtils.extractRequiredParams(this.$route.params),
                                ...selected,
                            }
                        })
                        .then((route: any) => {
                            ComponentEventBus.$emit('sponsorChanged', selected.sponsorKey);
                        });
                }
            });
        });
    }
}
